module.exports = __webpack_public_path__ + "img/zhengque_sel.e595d7d5.png";